<script>
    import ShopsCollection from '../components/shops/ShopsCollection.vue';

    export default {
      components: { ShopsCollection },
    };
</script>